import React from 'react';
import {
  Container,
  Paper,
  Typography,
  Box,
  Button,
  Avatar,
  Grid,
  Chip,
} from '@mui/material';
import {
  Construction as ConstructionIcon,
  ArrowBack as ArrowBackIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function PlaceholderPage({ 
  title, 
  description, 
  icon, 
  color = '#1976d2',
  features = [] 
}) {
  const navigate = useNavigate();

  const defaultFeatures = [
    'Data Management',
    'CRUD Operations',
    'Search & Filter',
    'Export Functionality',
    'Real-time Updates',
    'Responsive Design',
  ];

  const displayFeatures = features.length > 0 ? features : defaultFeatures;

  return (
    <Container maxWidth={false}>
     

      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: 'center',
          borderRadius: 2,
        }}
      >
        {/* Header */}
        <Avatar
          sx={{
            bgcolor: color,
            width: 80,
            height: 80,
            mx: 'auto',
            mb: 3,
          }}
        >
          {icon}
        </Avatar>

        <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', mb: 2 }}>
          {title}
        </Typography>

        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          {description || `Manage your ${title.toLowerCase()} efficiently with our comprehensive tools.`}
        </Typography>

        {/* Under Construction Notice */}
        <Box
          sx={{
            backgroundColor: '#fff3cd',
            border: '1px solid #ffeaa7',
            borderRadius: 2,
            p: 3,
            mb: 4,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
            <ConstructionIcon sx={{ color: '#b8860b', mr: 1 }} />
            <Typography variant="h6" sx={{ color: '#b8860b', fontWeight: 'bold' }}>
              Coming Soon
            </Typography>
          </Box>
          <Typography variant="body1" sx={{ color: '#856404' }}>
            This module is currently under development. Check back soon for full functionality!
          </Typography>
        </Box>

        {/* Planned Features */}
        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3 }}>
          Planned Features
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          {displayFeatures.map((feature, index) => (
            <Grid item key={index}>
              <Chip
                label={feature}
                variant="outlined"
                sx={{
                  borderColor: color,
                  color: color,
                  '&:hover': {
                    backgroundColor: `${color}20`,
                  },
                }}
              />
            </Grid>
          ))}
        </Grid>

        {/* Action Buttons */}
        <Box sx={{ mt: 4 }}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate('/dashboard')}
            sx={{
              backgroundColor: color,
              '&:hover': {
                backgroundColor: color,
                filter: 'brightness(90%)',
              },
              mr: 2,
            }}
          >
            Return to Dashboard
          </Button>
          
          <Button
            variant="outlined"
            size="large"
            disabled
            sx={{
              borderColor: color,
              color: color,
            }}
          >
            Get Notified When Ready
          </Button>
        </Box>
      </Paper>
    </Container>
  );
} 